export const ListChannel = {
    AMAZON_JP: {
        ShortName: 'AMZ',
        Label: {
            "seller_id" : "SellerID",
            "auth_token" : "MWSAuthToken",
            "refresh_token": "RefreshToken",
        },
        NameFileExportItemMaster: "Amazon",
    },
    RAKUTEN: {
        ShortName: 'RKT',
        Label: {
            "seller_id" : "ServiceSecret",
            "auth_token" : "LicenseKey",
        },
        NameFileExportItemMaster: "Rakuten",

    },
    Y_SHIP: {
        ShortName: 'YSH',
        NameFileExportItemMaster: "Y-Ship"
         
    }
};


// WEBPACK FOOTER //
// ./src/constants/setting_channel.js